export const setStorageItem = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
};

export const getStorageItem = (key) => {
    const item = localStorage.getItem(key);

    if (item) {
        return JSON.parse(item);
    }

    return null;
};

export const removeStorageItem = (key) => {
    localStorage.removeItem(key);
};
